module.exports = __webpack_public_path__ + "img/mis_news_111221.83bb24e8.jpg";